import React from "react";

import { cn } from "@/helpers/tailwind";
import { s3BucketURL } from "@/helpers/environment";

interface HypeMeterProps {
  percentage: number; // 0 - 100
  className?: string;
}

export const HypeMeter: React.FC<HypeMeterProps> = ({
  percentage,
  className,
}) => {
  const filledWidth = Math.ceil(percentage);

  return (
    <div
      className={cn(
        // todo: change to bg-slate-600 & update percentage.svg
        "relative flex h-[10px] w-full overflow-hidden rounded-full bg-slate-700",
        className
      )}>
      <div
        className="absolute right-0 top-0 h-full bg-inherit"
        style={{ width: `${100 - filledWidth}%` }}
      />
      <div
        className="absolute inset-0 h-full w-full bg-no-repeat"
        style={{
          backgroundImage: `url(${s3BucketURL}percentage.svg)`,
          backgroundRepeat: "repeat-x",
        }}
      />
      <div
        className={cn(
          "h-full w-full bg-gradient-to-r",
          "from-[#3AFFFF] via-[#66D466] to-[#FF3A3A]"
        )}
      />
    </div>
  );
};
